import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Carousel from '@src/components/Carousel';
import Separator from '@src/components/Separator';
import { H2, Subtitle1 } from '@src/components/Typography';
import { idKeyExtractor, padding } from '@src/configuration/constants';
import { ImmigrationPlan, Slide } from '@src/types';

export const Slides = styled.View`
  min-height: 230px;
  margin-bottom: 10px;
`;

export const Plans = styled.View`
  min-height: 100px;
`;

export const Controls = styled.View`
  padding: ${padding}px;
`;

export const ContentTitle = styled(H2)`
  text-align: center;
`;

export const ContentSubtitle = styled(Subtitle1)`
  text-align: center;
`;

export const ImmigrationPlanList = styled(
  FlatList as new () => FlatList<ImmigrationPlan>
).attrs(() => ({
  removeClippedSubviews: true,
  initialNumToRender: 3,
  maxToRenderPerBatch: 3,
  scrollEventThrottle: 16,
  keyExtractor: idKeyExtractor,
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  ItemSeparatorComponent: Separator,
  horizontal: true,
}))``;

export const PlansCarousel = styled(
  Carousel as new () => Carousel<Slide>
).attrs(() => ({
  loop: true,
  directionalLockEnabled: true,
  enableMomentum: true,
}))``;
